<emr-modal headerTitle="Update Shipment" i18n-headerTitle="@@link_edit_shipment" [bsModalRef]=bsModalRef
    [showCloseButton]=showCloseButton>
    <div modal-body>
        <div class="m-1 p-1 errorMsgCss">
            <div *ngIf="hasError; else noError">
                <p>{{ errorMessage }}</p>
            </div>
            <div *ngIf="hasError && debugErrorMessage">
                <hr>
                <p>{{ debugErrorMessage }}</p>
            </div>
            <ng-template #noError>
                <p i18n="@@shipment_updated_successfully">Shipment updated successfully</p>
            </ng-template>
        </div>
        <div class="col-12 text-center">
            <emr-button identifier="editShipmentOk" buttonType="button" buttonText="Ok" i18n-buttonText="@@link_ok"
                cssClass="btn button-text btn button-text btn-outline-default mt-0 mb-2" (click)='onOkClick()'>
            </emr-button>
        </div>
    </div>
</emr-modal>